/**
 * The reason an app admin gives for changing records inside another organisation (owner,
 * 2026-09-22: "when i edit the app (CRUD), then reason is must to be recorded").
 *
 * The database decides when one is needed: a write without it is refused with
 * VANA_REASON_REQUIRED. The data layer then asks here, a dialog (ChangeReasonHost) collects it,
 * and the write is retried with the reason attached. One reason covers the writes of the next two
 * minutes, so a single save that writes a row, uploads a file and links it asks only once.
 */
const REUSE_MS = 2 * 60 * 1000;
let cached: { text: string; at: number } | null = null;
let prompt: ((message: string) => Promise<string | null>) | null = null;

export function registerReasonPrompt(ask: typeof prompt) {
  prompt = ask;
}

export function currentReason(): string | null {
  return cached && Date.now() - cached.at < REUSE_MS ? cached.text : null;
}

export function forgetReason() {
  cached = null;
}

export function isReasonRequired(message?: string | null): boolean {
  return Boolean(message && message.includes('VANA_REASON_REQUIRED'));
}

/** Ask for a reason (the dialog); null when the person cancels. */
export async function obtainReason(message: string): Promise<string | null> {
  if (!prompt) return null;
  const text = await prompt(message.replace(/^.*VANA_REASON_REQUIRED:\s*/, ''));
  if (text && text.trim()) {
    cached = { text: text.trim(), at: Date.now() };
    return cached.text;
  }
  return null;
}
